import React from 'react';
import { Container, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { getToken, logout } from '../../services/AuthService';
import permissions from '../config/routePermissions';

const getUserInfo = () => {
  const token = getToken();
  if (token && token.split('.').length === 3) {
    try {
      const decoded = JSON.parse(atob(token.split('.')[1]));
      return {
        username: decoded?.Username || 'Usuario',
      };
    } catch {
      return { username: 'Usuario' };
    }
  }
  return { username: 'Usuario' };
};

const NavigationBar = () => {
  const navigate = useNavigate();
  const { username } = getUserInfo();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const token = getToken();
  if (!token) return null;

  const visibleRoutes = permissions.filter(r => r.friendlyName && r.roles.some(fn => fn()));

  const groupByPrefix = (routes, prefix) =>
    routes.filter(r => r.path.startsWith(prefix) && r.path === prefix);

  const renderNavItem = (items, title, dropdownId) => {
    if (items.length === 1) {
      return (
        <Nav.Link key={items[0].path} as={Link} to={items[0].path}>
          {items[0].friendlyName}
        </Nav.Link>
      );
    }
    return (
      <NavDropdown title={title} id={dropdownId} align="end">
        {items.map(r => (
          <NavDropdown.Item key={r.path} as={Link} to={r.path}>
            {r.friendlyName}
          </NavDropdown.Item>
        ))}
      </NavDropdown>
    );
  };

  return (
    <Navbar expand="lg" bg="dark" variant="dark">
      <Container fluid>
        <Navbar.Brand>
          <Link to="/" className="navbar-brand">KAMA Y KANAPE</Link>
        </Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse>
          <Nav className="ms-auto">
            {groupByPrefix(visibleRoutes, '/delivery').map(r => (
              <Nav.Link key={r.path} as={Link} to={r.path}>{r.friendlyName}</Nav.Link>
            ))}
            {groupByPrefix(visibleRoutes, '/orderItemsByCarrier').map(r => (
              <Nav.Link key={r.path} as={Link} to={r.path}>{r.friendlyName}</Nav.Link>
            ))}
            {groupByPrefix(visibleRoutes, '/transport').map(r => (
              <Nav.Link key={r.path} as={Link} to={r.path}>{r.friendlyName}</Nav.Link>
            ))}
            {groupByPrefix(visibleRoutes, '/calendar').map(r => (
              <Nav.Link key={r.path} as={Link} to={r.path}>{r.friendlyName}</Nav.Link>
            ))}
            {visibleRoutes.some(r => r.path.startsWith('/orders')) &&
              renderNavItem(
                visibleRoutes.filter(r => r.path.startsWith('/orders')),
                "Pedidos",
                "orders-dropdown"
              )
            }
            {groupByPrefix(visibleRoutes, '/clients').map(r => (
              <Nav.Link key={r.path} as={Link} to={r.path}>{r.friendlyName}</Nav.Link>
            ))}
            {visibleRoutes.some(r => r.path.startsWith('/lead-assignment') || r.path === '/lead-management' || r.path === '/lead-accounts' || r.path === '/daily-lead-stats' || r.path === '/lead-account-history') &&
              renderNavItem(
                visibleRoutes.filter(r => r.path.startsWith('/lead-assignment') || r.path === '/lead-management' || r.path === '/lead-accounts' || r.path === '/daily-lead-stats' || r.path === '/lead-account-history'),
                "Leads",
                "leads-dropdown"
              )
            }
            {groupByPrefix(visibleRoutes, '/products').map(r => (
              <Nav.Link key={r.path} as={Link} to={r.path}>{r.friendlyName}</Nav.Link>
            ))}
            {visibleRoutes.some(r =>
              r.path === '/salesreps/commissions' ||
              r.path === '/carriers/commissions'
            ) &&
              renderNavItem(
                visibleRoutes.filter(r =>
                  r.path === '/salesreps/commissions' ||
                  r.path === '/carriers/commissions'
                ),
                "Comisiones",
                "commissions-dropdown"
              )
            }
            {visibleRoutes.some(r => r.path.startsWith('/users') || (r.path.startsWith('/salesreps') && r.path !== '/salesreps/commissions') || (r.path.startsWith('/carriers') && r.path !== '/carriers/commissions') || ['/product-variants', '/special-products', '/carrier-zip-prefixes', '/events', '/carriers/commissions/products', '/telegram-channel-assignments', '/logs', '/analytics', '/zipcode-map'].includes(r.path)) &&
              renderNavItem(
                visibleRoutes.filter(r =>
                  ['/product-variants', '/special-products', '/users', '/salesreps', '/carriers', '/carrier-zip-prefixes', '/events', '/carriers/commissions/products', '/telegram-channel-assignments', '/logs', '/analytics', '/zipcode-map'].includes(r.path)
                ),
                "Gestión",
                "management-dropdown"
              )
            }
            <NavDropdown title={username} id="user-dropdown" align="end">
              <NavDropdown.Item as={Link} to="/settings">Ajustes</NavDropdown.Item>
              <NavDropdown.Item onClick={handleLogout}>Cerrar sesión</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
